<script setup lang="ts">
import SvgLevelChildhood from "@/assets/svg/level-childhood.svg";
import SvgLevelElementary from "@/assets/svg/level-elementary.svg";
import SvgLevelSecondary from "@/assets/svg/level-secondary.svg";
import SvgLevelFga from "@/assets/svg/level-fga.svg";
import SvgLevelFp from "@/assets/svg/level-fp.svg";
import SvgLevelCEGEP from "@/assets/svg/level-collegial.svg";

defineProps<{
  level: LevelName;
  url: string;
}>();

const svg = {
  childhood: SvgLevelChildhood,
  elementary: SvgLevelElementary,
  secondary: SvgLevelSecondary,
  fga: SvgLevelFga,
  fp: SvgLevelFp,
  collegial: SvgLevelCEGEP,
};

const label = {
  childhood: wp.i18n.__("Early childhood", "egalite"),
  elementary: wp.i18n.__("Elementary", "egalite"),
  secondary: wp.i18n.__("High school", "egalite"),
  fga: wp.i18n.__("Adult education", "egalite"),
  fp: wp.i18n.__("Vocational training", "egalite"),
  collegial: wp.i18n.__("CEGEP", "egalite"),
};
</script>

<template>
  <a :href="url" class="flex flex-col text-center group rounded-3xl text-level transition hover:bg-level hover:text-white" :class="`color-${level}`">
    <Component :is="svg[level]" class="p-3 -mb-4 w-full aspect-2/1 fill-current z-10" />
    <h3 class="heading-4 bg-level text-white p-3 rounded-3xl">
      {{ label[level] }}
    </h3>
  </a>
</template>
